// extracted by mini-css-extract-plugin
export default {"output":"OutputPinCircle_output__A-L7I"};